import { ListOptionsFormController } from '@shared/list-options/list-options-form.controller';

import { USER_LIST_COLUMN_LABEL_I18N_KEY } from '../user-list/user-list.config';
import { useUserListContext } from '../user.context';

export const UserListOptionsController = (): React.JSX.Element => {
  const { columnOptions, setColumnOptions } = useUserListContext();

  return (
    <ListOptionsFormController
      columnOptions={columnOptions}
      columnLabelMap={USER_LIST_COLUMN_LABEL_I18N_KEY}
      onChange={setColumnOptions}
    />
  );
};
